import React from 'react';
import PropTypes from 'prop-types';

class InsufficientData extends React.Component {
  render() {
    return (
      <div
        style={{
          backgroundColor: '#Ffff',
          borderRadius: '8px',
          padding: '0.8rem',
          textAlign: 'center',
          width: 'auto',
          height: 'auto',
          marginTop: '1rem'
        }}
      >
        <h1 style={{ color: '#535059', fontSize: '1rem', fontWeight: 'bold' }}>
          Ainda não há dados suficientes para gerar este relatório
        </h1>
      </div>
    );
  }
}

export default InsufficientData;
